import React, { useState, useEffect } from "react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { PortfolioImages } from "../assets/portfolio";
import { motion } from "framer-motion";
import { Hearts } from "react-loader-spinner";
import {
  LazyLoadImage,
  trackWindowScroll,
} from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const Portfolio = ({ scrollPosition }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadImages = PortfolioImages.slice(0, 15).map(
      (image) =>
        new Promise((resolve) => {
          const img = new Image();
          img.src = image.src;
          img.onload = () => resolve();
          img.onerror = () => resolve(); // Resolve on error to prevent infinite loading
        })
    );

    // Wait until the first 5 images have loaded
    Promise.all(loadImages).then(() => setIsLoading(false));
  }, []);

  const spinner = () => (
    <Hearts
      height="90"
      width="90"
      color="#fecdd3b3"
      ariaLabel="hearts-loading"
      wrapperStyle={{}}
      wrapperClass=""
      visible={true}
    />
  );

  return (
    <motion.div
      className="m-5 lg:m-20"
      initial={{ opacity: 0, y: 100 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.175 }}
    >
      {isLoading ? (
        <div
          style={{ display: "flex", justifyContent: "center" }}
          className="my-60"
        >
          {spinner()}
        </div>
      ) : (
        <ResponsiveMasonry
          columnsCountBreakPoints={{ 350: 1, 768: 2, 1024: 3 }}
        >
          <Masonry gutter="10px">
            {PortfolioImages.map((image, i) => (
              <div key={i} style={{ position: "relative", width: "100%" }}>
                <LazyLoadImage
                  src={image.src}
                  alt={image.alt}
                  effect="blur"
                  scrollPosition={scrollPosition}
                  visibleByDefault={i < 8} // Load the first 8 images immediately
                  style={{ width: "100%", display: "block" }}
                  beforeLoad={() => (
                    <div
                      style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "#f0f0f0", // Same as placeholder color
                      }}
                    />
                  )}
                />
              </div>
            ))}
          </Masonry>
        </ResponsiveMasonry>
      )}
    </motion.div>
  );
};

export default trackWindowScroll(Portfolio);
